//import React from 'react'
import React, { useContext, useEffect, useState, useMemo } from 'react';
import { Box, Typography } from '@mui/material'
import css from '../../css/login.module.css';
import { Link } from 'react-router-dom';
import {MdOutlinePortrait} from 'react-icons/md';
import { PasswordRounded } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import {CgProfile as ProfileIcon} from 'react-icons/cg';
import useAuth from '../../hooks/useAuth';
import {CiLock as LockIcon, CiUnlock as UnlockIcon} from 'react-icons/ci';
import apiCall from '../../utils/apiCall';
import { useMutation } from '@tanstack/react-query';
import { NotificationContext } from '../../providers/notification';
import jwt_decode from 'jwt-decode'
import {useSelector, useDispatch} from 'react-redux'
import { updateUser } from '../../reduxSlice/userSlice';
import {RootState} from '../../redux/store';
import { BsAsterisk } from 'react-icons/bs';

// let newUser = true;//This variable should be sent from the backend and updated when the user reset their password successfully.;

interface Payload {
  Email: string;
  Password: string;
}

interface LoginData {
  Token: string;
  UserName: string;
  Id: string;
  expiryDate: string;
  RoleNames: string[];
  AdminUserHasChangePassword?:boolean;
  FirstName:string;


}

interface JwtData {
  nameid: string;
  email: string;
  role: string;
  RoleId: string;
}

const lightText:string = "#D2EAE1";

const Login = (props:any) => {
  const token  = useSelector((state: RootState) =>state?.user.token );
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [showPassword,setShowPassword] = useState<boolean>(false);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [justLoggedIn,setJustLoggedIn] = useState<boolean>(false);
  const setUserHasChangePassword = props.onChange;

  const { user, setUser } = useAuth();
  const { showNotification } = useContext(NotificationContext);

  const memoToken = useMemo(() => token, [token]);

  const handlePassword = () => {
    setShowPassword(!showPassword)
  };

  useEffect(() => {
    if(token && justLoggedIn ){
      setJustLoggedIn(false);
      navigate('/dashboard/overview');
    }
  }, [memoToken,justLoggedIn]);
// debugger;
  const login = async (data: Payload) => {
    return (await (apiCall().post('/Administration/post/auth/user', data)))?.data as LoginData;
  };
  
  // useEffect(() => {
  //   setUsername('');
  //   setPassword('');
  // }, []);

  const loginMutation = useMutation(['post-user'], login, {retry: 0});

  const loginHandler = async (e: React.FormEvent) => {
    e.preventDefault();
  
    const loginUser: Payload = {
      Email: username,
      Password: password
    };

try {
  await loginMutation.mutateAsync(loginUser, {
    onSuccess: (data) => {
      setJustLoggedIn(true);
      localStorage.setItem('AdminUserHasChangePassword', data?.AdminUserHasChangePassword?.toString() || '');
      let passwordChange = data?.AdminUserHasChangePassword ? true : false;
      setUserHasChangePassword(passwordChange);

      let FirstN = data.FirstName;
      
      const {
        nameid,
        email,
        role,
        RoleId,
      } = jwt_decode(data?.Token) as JwtData;

      const roleName = role?.split(',')[0];
      const id = RoleId?.split(',')[0];
      
      localStorage.setItem('token', JSON.stringify(data?.Token));

   dispatch(updateUser({ 
    userId: nameid, 
    email, 
    role: roleName, 
    token: data?.Token, 
    roleId: id,
    FirstName: FirstN,
    RoleNames: data?.RoleNames ?? [], // ✅ already an array, no .split() needed
  }));
    },
  });
} catch (error: any) {
      // if(error.response.data.StatusCode == 400){
        showNotification({
          message:'Invalid username or password',
          type: 'error'
        });
      // }
      // else{
      //   showNotification({
      //   message: error?.response?.data?.Message || error?.message,
      //   type: 'error'
      // });
      // }
      
  }
}

  return (
    <Box autoComplete={"chrome-off"} component="form" className={css.form} onSubmit={loginHandler}>
      <Typography component="h1" children={"Log In"} 
        sx={{fontWeight: "bold", color: "white", fontSize: "22px"}} align="center" 
      />
      <Typography component="p" children={"Take a step ahead to track applications"} 
        sx={{color:lightText,fontSize:"12px"}} align="center" mt={1} mb={5}
      />
      <label>
        <div>E-mail</div>
        <input autoComplete={"chrome-off"} value={username} onChange={(e => setUsername(e.target.value))} type="email" placeholder='Enter your E-mail' required={true}/>
        <span data-testid='span'><ProfileIcon /></span>
      </label>
      {/* <span>Good</span> */}
      <label>
        <div>Password</div>
        <input value={password} onChange={(e => setPassword(e.target.value))} type={showPassword ? 'text' : 'password'} placeholder='Password' required={true} />
        <span onClick={handlePassword}>
          {showPassword ? <UnlockIcon /> : <LockIcon />}
        </span>
      </label>
      <input
        type="submit" 
        role='button'
        disabled={loginMutation.isLoading} 
        value={loginMutation.isLoading ? "Login......" : "Log In"} 
        style={{cursor:"pointer"}}
        data-testid ='login'
      />
      <Typography component={'div'} sx={{ color: lightText, mt: 3, mb: 3, fontSize: "12px", display: "flex", justifyContent: "space-between"}}>
        <span>Did you forget you password?</span>
        <Link to="/forgot-password" style={{color:"white"}} >
          Reset Password
        </Link>
      </Typography>
    </Box>
  )
}

export default Login;